import { Component, EventEmitter, Output, OnInit, inject } from '@angular/core';
import { ClientConsentFormsService } from 'src/app/core/services/client-consent-forms.service';

type ClientConsentSectionsResponse = {
  data?: Record<string, string>;
};

@Component({
  selector: 'app-section-selector-modal',
  templateUrl: './section-selector-modal.component.html',
})
export class SectionSelectorModalComponent implements OnInit {
  @Output() selectionConfirmed = new EventEmitter<number[]>(); // Emitirá las secciones seleccionadas
  @Output() errorOccurred = new EventEmitter<string>(); // Emitirá un error si no hay secciones seleccionadas

  sections: { key: string; label: string; selected: boolean }[] = [
    { key: 'background', label: 'Background Information', selected: true },
    { key: 'maladaptives', label: 'Maladaptive Behaviors', selected: true },
    { key: 'assessmentsConducted', label: 'Assessments Conducted', selected: true },
    { key: 'prevalentSetting', label: 'Prevalent Setting Events & Antecedents', selected: true },
    { key: 'hypothesisBasedInterventions', label: 'Hypothesis-based Interventions', selected: true },
    { key: 'interventions', label: 'Interventions', selected: true },
    { key: 'maladaptiveGoals', label: 'Maladaptive Goals', selected: true },
    { key: 'replacementGoals', label: 'Replacement Goals', selected: true },
    { key: 'familyInvolvement', label: 'Family/Caregiver Training/Involvement', selected: true },
    { key: 'monitoringEvaluating', label: 'Monitoring y Evaluating the Effectiveness of the plan/ Treatment Fidelity', selected: true }
  ];
  allSelected = true; // Estado inicial:

  private clientConsentFormsService = inject(ClientConsentFormsService);

  ngOnInit() {
    this.loadSections();
  }

  private loadSections() {
    this.clientConsentFormsService.getClientConsentSections().subscribe({
      next: (response: unknown) => {
        const safeResponse = response as ClientConsentSectionsResponse;
        if (safeResponse?.data) {
          this.sections = Object.keys(safeResponse.data).map((key: string) => ({
            key: key,
            label: safeResponse.data?.[key] ?? key,
            selected: true
          }));
        }
      },
      error: (error) => {
        console.error('Error loading sections:', error);
        this.errorOccurred.emit('Error loading sections. Please try again.');
      }
    });
  }

  toggleSelection(): void {
    this.allSelected = !this.allSelected; // Cambiar el estado
    this.sections.forEach((section) => (section.selected = this.allSelected)); // Seleccionar o deseleccionar todas
  }

  confirmSelection() {
    // console.log(
    //   'Confirming selection... ############################################################# ',
    //   this.sections
    // ); // Depuración
    const selectedSections = this.sections
      .filter((section) => section.selected)
      .map((section) => Number(section.key));

    // console.log('Selected sections:', selectedSections); // Depuración

    if (selectedSections.length === 0) {
      // Emitir un error si no hay secciones seleccionadas
      this.errorOccurred.emit('You must select at least one section.');
      console.log('Error emitted: No sections selected'); // Depuración
      return;
    }

    // Close the modal by triggering the close button
    const closeBtn = document.querySelector('.btn-close') as HTMLElement;
    closeBtn?.click();

    this.selectionConfirmed.emit(selectedSections);
  }}
